import { useIntl } from 'react-intl';

import { XING_JOBS_SEARCH_KI_PATH } from '@xing-com/crate-core-routes';
import { useExperiment } from '@xing-com/hub';
import {
  IconCompanies,
  IconCompaniesFilled,
  IconContacts,
  IconContactsFilled,
  IconJobs,
  IconJobsFilled,
  IconNews,
  IconNewsFilled,
  IconSearch,
  IconSearchFilled,
} from '@xing-com/icons';
import { ProductsMenuWithItemsLoggedOut } from '@xing-com/platform-layout-products-menu';

import { ActivityCenterButton } from '../activity-center-button';
import { ActivityCenterLoginButton } from '../activity-center-login-button';
import { CreateJobButton } from '../create-job-button';
import {
  ActionButtonSpace,
  StyledOnlyOnBigScreenContainer,
} from '../header/header.styled';
import { LoginButton } from '../login-button';
import { NavItemHeader } from '../nav-item-header';

type HeaderNavItemsLoggedOutProps = {
  loginLink?: string;
};

export const HeaderNavItemsLoggedOut: React.FC<
  HeaderNavItemsLoggedOutProps
> = ({ loginLink }) => {
  const { formatMessage } = useIntl();
  const isOptimisedNavigationExperiment = useExperiment('XDS-4636') === 'B';

  return (
    <>
      <StyledOnlyOnBigScreenContainer>
        <NavItemHeader
          activeItemValues={['jobs']}
          icon={IconJobs}
          activeIcon={IconJobsFilled}
          title={formatMessage({ id: 'MAINNAV_JOBS_FIND' })}
          href="https://www.xing.com/"
          tracking={{
            nwt_nav: 'find_jobs',
          }}
        />
        <NavItemHeader
          activeItemValues={['companies']}
          icon={IconCompanies}
          activeIcon={IconCompaniesFilled}
          title={formatMessage({ id: 'MAINNAV_COMPANIES' })}
          href="https://www.xing.com/companies"
          tracking={{
            nwt_nav: 'companies',
          }}
        />
        <NavItemHeader
          icon={IconContacts}
          activeIcon={IconContactsFilled}
          title={formatMessage({ id: 'MAINNAV_NETWORK' })}
          href="https://www.xing.com/network"
          activeItemValues={['members']}
          tracking={{
            nwt_nav: 'network',
          }}
        />
        <NavItemHeader
          icon={IconNews}
          activeIcon={IconNewsFilled}
          title={formatMessage({ id: 'MAINNAV_INSIGHTS' })}
          href="https://www.xing.com/insights"
          activeItemValues={['insights']}
          tracking={{
            nwt_nav: 'insights',
          }}
        />
        <NavItemHeader
          icon={IconSearch}
          activeIcon={IconSearchFilled}
          title={formatMessage({ id: 'FRAME_HEADER_SEARCH' })}
          href={`https://www.xing.com${XING_JOBS_SEARCH_KI_PATH}`}
          activeItemValues={['job-search']}
          tracking={{
            nwt_nav: 'job_search',
          }}
        />
      </StyledOnlyOnBigScreenContainer>
      {isOptimisedNavigationExperiment ? (
        <>
          <ActivityCenterLoginButton
            title={formatMessage({ id: 'MAINNAV_LOGIN' })}
            href="https://www.xing.com/activity"
            loginLink={loginLink}
          />
          <ActionButtonSpace>
            <CreateJobButton />
          </ActionButtonSpace>
        </>
      ) : (
        <>
          <ActivityCenterButton
            title={formatMessage({ id: 'MAINNAV_ACTIVITY_CENTER' })}
            href="https://www.xing.com/activity"
          />
          <ActionButtonSpace>
            <LoginButton loginLink={loginLink} />
          </ActionButtonSpace>
        </>
      )}
      <StyledOnlyOnBigScreenContainer>
        <ProductsMenuWithItemsLoggedOut />
      </StyledOnlyOnBigScreenContainer>
    </>
  );
};
